import { jsx as _jsx } from "react/jsx-runtime";
import { DietaryTagCodes } from "@wmart/shared-types";
const LABELS = {
    vegan: "Vegan",
    vegetarian: "Vegetarian",
    halal: "Halal",
    kosher: "Kosher",
    organic: "Organic",
    gluten_free: "Gluten-free",
};
export function DietaryChipPicker({ value, onChange, }) {
    function toggle(code) {
        if (value.includes(code))
            onChange(value.filter((c) => c !== code));
        else
            onChange([...value, code]);
    }
    return (_jsx("div", { className: "flex flex-wrap gap-2", children: DietaryTagCodes.options.map((code) => {
            const on = value.includes(code);
            return (_jsx("button", { type: "button", onClick: () => toggle(code), "aria-pressed": on, className: `rounded-pill px-3 py-1 text-caption font-medium ${on
                    ? "bg-success-soft text-success"
                    : "bg-paper border border-ink-200 text-ink-700 hover:bg-paper-warm"}`, children: LABELS[code] }, code));
        }) }));
}
